import BaseStore from 'stores/base'

export default class HomeStore extends BaseStore {
  constructor(api, options) {
    super(api)
    this.api = api
    this.options = options
  }
}
